// Copyright (c) 2023 Jürgen Gebath
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT
import HideOnScroll from "../components/HideOnScroll";
import Header from "../components/Header";
import ScrollTop from "../components/ScrollTop";
import Footer from "../components/Footer";
import { Fab, Container } from "@mui/material";
import { KeyboardArrowUp } from "@mui/icons-material";
import { Outlet } from "react-router-dom";
import { styled } from "@mui/system";
import { useTheme } from "@mui/material/styles";
import { useRef } from "react";

export default function Layout(props) {
  const theme = useTheme();
  const ref = useRef();

  const TopPosition = styled("p")({
    position: "relative",
    top: 12,
  });

  // <div> around Header in HideOnScroll is necessary to prevent runtime error with Slide component
  return (
    <>
      <HideOnScroll ref={ref}>
        <div>
          <Header />
        </div>
      </HideOnScroll>
      <TopPosition id="top" />
      <Container>
        <Outlet />
      </Container>
      <ScrollTop>
        <Fab
          size="small"
          aria-label="scroll back to top"
          sx={{
            bgcolor: theme.palette.primary.main,
            color: theme.palette.text.brand,
          }}>
          <KeyboardArrowUp />
        </Fab>
      </ScrollTop>
      <Footer />
    </>
  );
}
